import React, { useState, useEffect } from 'react'
import { browserHistory } from 'react-router'
import PropTypes from 'prop-types'
import { Row, Col, Button } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { ContactUsModalContainer } from '../../containers'
import TrackingHOC from '../../hocs/TrackingHOC'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { OptionsHOC } from '../../hocs'
import AirfindAd from '../AirfindAd'
import { upperCaseFirstLetter } from '../../helpers/utils'

import { Wrapper } from './styles'
import messages from './messages'
import { useAppContext } from '../../containers/App/Context'

const MoreHelpFooter = ({
  track,
  createUserEvent,
  language,
  contactOptions,
  getOption
}) => {
  const [isShowModal, setIsShowModal] = useState(false)
  const [showDefaultAd, setShowDefaultAd] = useState(false)
  const { versionKey: version } = useAppContext()

  const modalClose = () => {
    setIsShowModal(false)
  }

  const showModal = () => {
    createUserEvent({
      category: 'navigation',
      data: { link_to: '#contact', source: 'ContactMainMoreHelp' }
    })
    track('Contact', 'Contact Us')

    setIsShowModal(true)
  }

  /** Dynamic vars that handle the injection of AirfindAd in its various locations */
  const showAdTop = getOption('ad.showAdTop')
  const showAdBottom = getOption('ad.showAdBottom')
  const isExpressPage = browserHistory
    .getCurrentLocation()
    .pathname.includes('expresshelp')
  /**
   * Side effect to ensure only one AirfindAd instance is visible in ExpressContent
   * which is where the only other injection of AirfindAd exists
   */
  useEffect(() => {
    /** If we're in Express and ad.showAdTop is enabledd, hide it in the footer */
    if (isExpressPage && showAdTop) {
      setShowDefaultAd(false)
    } else {
      /** Otherwise default to true, handle showAdBottom separately */
      setShowDefaultAd(true)
    }
  }, [showAdTop, isExpressPage])

  const translated = messages[language]
  const contactUsButtonText = getOption(
    'moreHelpFooter.contactUsButtonText',
    translated['contact']
  )
  const titleText = getOption('moreHelpFooter.titleText', translated['title'])
  const text = getOption('moreHelpFooter.text', translated['body'])

  if (
    contactOptions.length === 0 ||
    contactOptions[0].link_location === 'hide'
  ) {
    return null
  }

  return (
    <Wrapper showDefaultAd={showDefaultAd && showAdBottom} version={version}>
      {showDefaultAd && showAdBottom && (
        <AirfindAd id="ad-footer" show={showDefaultAd && showAdBottom} />
      )}
      <ContactUsModalContainer show={isShowModal} onHide={() => modalClose()} />
      <Row>
        <Col id="more-help">
          <h2>{upperCaseFirstLetter(titleText)}</h2>
          <p>{text}</p>

          <Button tabIndex="0" onClick={() => showModal()}>
            <a className="line">{contactUsButtonText}</a>
          </Button>
        </Col>
      </Row>
    </Wrapper>
  )
}

MoreHelpFooter.propTypes = {
  track: PropTypes.func,
  createUserEvent: PropTypes.func,
  language: PropTypes.string,
  contactOptions: PropTypes.array,
  getOption: PropTypes.func
}

export default LanguageProvider(OptionsHOC(TrackingHOC(MoreHelpFooter)))



// WEBPACK FOOTER //
// ./src/components/MoreHelpFooter/MoreHelpFooter.js